import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-studio-report',
  templateUrl: './data-studio-report.component.html',
  styleUrls: ['./data-studio-report.component.scss']
})
export class DataStudioReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
